<template>
  <form @submit.prevent="">
    <z-dialog :show="isVisible" :modal-size="modalSize">
      <template #header>
        <div class="row custom-header">
          <div class="col-11">
            <h4 class="modal-title">
              {{ title }}
            </h4>
          </div>
          <div class="col-1">
            <a href="#" class="custom-close" @click="close">
              <i class="fa fa-times"></i>
            </a>
          </div>
        </div>
      </template>
      <template #body>
        <z-tabs v-model="currentTab" :tabs="tabs" @change="showTab" />
        <div v-if="currentTab === 'Details'" class="custom-tab">
          <div class="row mt-2">
            <div class="col">
              <div class="input-group">
                <span class="input-group-text">Name:<span class="custom-required">*</span></span>
                <input v-model="blogName" type="text" class="form-control" />
              </div>
            </div>
            <div class="col-5">
              <div class="custom-sticky">
                <input v-model="isSticky" type="checkbox" class="custom-checkbox" />
                <span class="custom-sticky-label">Keep to the top, with sort:</span>
                <input
                  v-model="sort"
                  class="form-control custom-sort"
                  type="number"
                  min="0"
                  max="9999"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="input-group">
                <span class="input-group-text">Type:<span class="custom-required">*</span></span>
                <select v-model="blogType" class="form-control">
                  <option v-for="item of blogTypes" :key="item.value" :value="item.value">
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-5">
              <div class="input-group">
                <span class="input-group-text">Status:<span class="custom-required">*</span></span>
                <select v-model="blogStatus" class="form-control">
                  <option v-for="item of blogStatuses" :key="item.value" :value="item.value">
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col form-group custom-editor">
              <editor ref="zEditor" v-model:content="content" content-type="html" />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col">
              <z-input v-model="blogTags" name="tags" placeholder="Tags (comma-delimited)" />
            </div>
          </div>
          <div class="row">
            <div class="col">
              <input v-model="isAllowComments" type="checkbox" class="custom-checkbox ms-2" />
              <span class="ms-1">Allow Comments</span>
            </div>
            <div class="col">
              <!-- <input v-model="isIncludeShop" type="checkbox" class="custom-checkbox" />
              <span class="ms-1">Include Shop Location</span> -->
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-5">
              <div class="input-group">
                <span class="input-group-text">Publish On:</span>
                <input v-model="scheduledOn" name="scheduledOn" class="form-control" type="date" />
              </div>
            </div>
            <div class="col"></div>
          </div>
          <div class="row">
            <div class="col"></div>
            <div class="col"></div>
          </div>
        </div>
        <div v-if="currentTab === 'Attachments'" class="custom-tab">
          <blog-attachment class="mt-2" @uploaded="uploaded" />
        </div>
      </template>
      <template #footer>
        <div class="custom-footer">
          <div class="col">{{ id }}</div>
          <div class="col-1">
            <button
              v-show="currentTab === 'Details' && !isNew"
              class="btn btn-light"
              @click="remove"
            >
              Delete
            </button>
          </div>
          <div class="col-6">
            <div class="custom-footer-buttons">
              <button class="btn btn-light" @click="close">Cancel</button>
              <button
                id="btn-submit"
                class="btn btn-primary"
                :class="[{ 'btn-danger': isSave }, { 'btn-primary': !isSave }]"
                @click="save"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </template>
    </z-dialog>
  </form>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { lookupStore } from '@/stores/lookup'
import { blogStore } from '@/stores/blog'
import moment from 'moment'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import ZInput from '@/components/utilities/elements/Input.vue'
import ZTabs from '@/components/utilities/elements/Tabs.vue'
import BlogAttachment from '@/components/blog/forms/blog-attachment.vue'
import Editor from '@/components/utilities/elements/Editor.vue'
export default {
  name: 'DialogConfigNotice',
  components: {
    ZDialog,
    ZInput,
    ZTabs,
    BlogAttachment,
    Editor
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modalSize: 'modal-lg',
      isSave: false,
      message: null,
      options: {
        maxHeight: '280px'
      },
      isScheduledChanged: false,
      currentTab: 'Details'
    }
  },
  emits: ['close', 'remove', 'saved'],
  computed: {
    ...mapState(lookupStore, ['lookups']),
    ...mapState(blogStore, ['blog']),
    isVisible() {
      return this.modelValue ? this.modelValue : false
    },
    tabs() {
      let _tabs = ['Details']
      if (!this.isNew) {
        _tabs.push('Attachments')
      }
      return _tabs
    },
    title() {
      let _data = 'Add Blog'
      if (this.blog) {
        if (this.blog.blog !== null) {
          _data = 'Edit Blog'
        }
      }
      return _data
    },
    id() {
      let _data = null
      if (this.blog) {
        _data = this.blog.blog
      }
      return _data
    },
    blogTypes() {
      let _types = []
      if (this.lookups['BlogType']) {
        this.lookups['BlogType'].forEach((element) => {
          _types.push({
            name: element.name,
            value: element.value
          })
        })
      }
      return _types
    },
    blogStatuses() {
      let _types = []
      if (this.lookups['BlogStatus']) {
        this.lookups['BlogStatus'].forEach((element) => {
          _types.push({
            name: element.name,
            value: element.value
          })
        })
      }
      return _types
    },
    isNew() {
      let _is = false
      if (this.blog) {
        if (this.blog.blog === null) {
          _is = true
        }
      }
      return _is
    },
    blogType: {
      get() {
        let _data = null
        if (this.blog) {
          _data = this.blog.blogType
        }
        return _data
      },
      set(value) {
        this.updateBlog({
          name: 'blogType',
          value: value
        })
        this.isSave = true
      }
    },
    blogStatus: {
      get() {
        let _data = null
        if (this.blog) {
          _data = this.blog.blogStatus
        }
        return _data
      },
      set(value) {
        this.updateBlog({
          name: 'blogStatus',
          value: value
        })
        this.isSave = true
      }
    },
    blogName: {
      get() {
        let _data = null
        if (this.blog) {
          _data = this.blog.blogName
        }
        return _data
      },
      set(value) {
        this.updateBlog({
          name: 'blogName',
          value: value
        })
        this.isSave = true
      }
    },
    content: {
      get() {
        let _data = null
        if (this.blog) {
          _data = this.blog.content
        }
        return _data
      },
      set(value) {
        let content = value
        this.updateBlog({
          name: 'content',
          value: content
        })
        this.isSave = true
      }
    },
    blogTags: {
      get() {
        let _data = null
        if (this.blog) {
          _data = this.blog.blogTags
        }
        return _data
      },
      set(value) {
        this.updateBlog({
          name: 'blogTags',
          value: value
        })
        this.isSave = true
      }
    },
    scheduledOn: {
      get() {
        let _data = null
        if (this.blog) {
          if (this.blog.scheduledOn) {
            _data = moment(this.blog.scheduledOn).format('YYYY-MM-DD')
          }
        }
        console.log('Scheduled On:', _data)
        return _data
      },
      set(value) {
        this.updateBlog({
          name: 'scheduledOn',
          value: moment(value).utc().format('YYYY-MM-DD')
        })
        this.isScheduledChanged = true
        this.isSave = true
      }
    },
    isSticky: {
      get() {
        let _data = null
        if (this.blog) {
          _data = this.blog.isSticky
        }
        return _data
      },
      set(value) {
        this.updateBlog({
          name: 'isSticky',
          value: value
        })
        this.isSave = true
      }
    },
    sort: {
      get() {
        let _data = null
        if (this.blog) {
          _data = this.blog.sort
        }
        return _data
      },
      set(value) {
        this.updateBlog({
          name: 'sort',
          value: value
        })
        this.isSave = true
      }
    },
    isAllowComments: {
      get() {
        let _data = null
        if (this.blog) {
          _data = this.blog.isAllowComments
        }
        return _data
      },
      set(value) {
        this.updateBlog({
          name: 'isAllowComments',
          value: value
        })
        this.isSave = true
      }
    },
    isIncludeShop: {
      get() {
        let _data = null
        if (this.blog) {
          _data = this.blog.isIncludeShop
        }
        return _data
      },
      set(value) {
        this.updateBlog({
          name: 'isIncludeShop',
          value: value
        })
        this.isSave = true
      }
    }
  },
  methods: {
    ...mapActions(blogStore, ['updateBlog', 'saveBlog']),
    close() {
      this.currentTab = 'Details'
      this.isSave = false
      this.isScheduledChanged = false
      this.message = null
      this.$emit('close')
    },
    remove() {
      this.$emit('remove')
    },
    showTab(value) {
      this.currentTab = value
    },
    uploaded() {
      this.isSave = true
    },
    cleanup(html) {
      // Create a new DOMParser
      var parser = new DOMParser()

      // Parse the copied HTML
      var doc = parser.parseFromString(html, 'text/html')

      // Get the root HTML element
      var rootHtmlElement = doc.documentElement

      // Create a new document to simplify the structure
      var simplifiedDoc = document.implementation.createHTMLDocument('')

      // Copy the head and body from the parsed HTML to the new document
      // simplifiedDoc.head.innerHTML = rootHtmlElement.querySelector('head').innerHTML;
      simplifiedDoc.body.innerHTML = rootHtmlElement.querySelector('body').innerHTML

      // Get the simplified HTML
      var simplifiedHtml = simplifiedDoc.documentElement.outerHTML

      // Now 'simplifiedHtml' contains the cleaned-up HTML
      console.log(simplifiedHtml)
      return simplifiedHtml
    },
    validate() {
      let isOkay = true
      this.message = ''
      if (this.content === null) {
        this.message = 'content'
        isOkay = false
      } else if (this.content.trim() === '') {
        this.message = 'content'
        isOkay = false
      }
      if (this.blogType === null) {
        if (this.message !== '') {
          this.message += ', '
        }
        this.message = 'type'
        isOkay = false
      }
      if (this.blogStatus === null) {
        if (this.message !== '') {
          this.message += ', '
        }
        this.message = 'status'
        isOkay = false
      }
      if (this.blogName === null) {
        if (this.message !== '') {
          this.message += ', '
        }
        this.message = 'name'
        isOkay = false
      } else if (this.blogName.trim() === '') {
        if (this.message !== '') {
          this.message += ', '
        }
        this.message = 'name'
        isOkay = false
      }
      return isOkay
    },
    async save() {
      if (this.isSave && this.validate()) {
        if (this.isScheduledChanged) {
          let temp = moment(this.scheduledOn).add(1, 'days').utc().format('YYYY-MM-DD')
          this.updateBlog({
            name: 'scheduledOn',
            value: temp
          })
        }
        this.updateBlog({
          name: 'content',
          value: this.cleanup(this.content)
        })
        await this.saveBlog()
        this.currentTab = 'Details'
        this.isScheduledChanged = false
        this.isSave = false
        this.message = null
        this.$emit('saved')
      } else {
        let msg = `Please provide ${this.message} prior to continuing.`
        alert(msg)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-textarea {
  height: 320px;
}
.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
.custom-footer-buttons {
  position: relative;
  float: right;
}
.custom-tab {
  position: relative;
  width: 100%;
}
.custom-required {
  position: relative;
  color: red;
  top: -5px;
  left: 5px;
}
.custom-sticky {
  position: relative;
  display: inline-flex;
}
.custom-sticky-label {
  margin-left: 10px;
  margin-top: 5px;
}
.custom-sort {
  width: 64px;
  text-align: right;
  margin-left: 10px;
}
.custom-editor {
  height: 300px;
  margin-bottom: 40px;
}
</style>
